import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import ComponentLayout from '../../../src/layouts/component-layout';
import anatomy from './images/anatomy.png';
import variants from './images/variants.png';
import doOverflow from './images/do-overflow.png';
import dontOverflow from './images/dont-overflow.png';
export const _frontmatter = {
  "title": "Breadcrumbs",
  "description": "Breadcrumbs display the current page within the site's hierarchy, allowing users to easily navigate to a different level."
};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const DoDontContainer = makeShortcode("DoDontContainer");
const Do = makeShortcode("Do");
const Caption = makeShortcode("Caption");
const Dont = makeShortcode("Dont");
const layoutProps = {
  _frontmatter
};
const MDXLayout = ComponentLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h2>{`Anatomy`}</h2>
    <img src={anatomy} alt="Breadcrumbs with location-based annotations for parent-level links, divider, and current page." />
    <h2>{`Usage`}</h2>
    <p>{`Use breadcrumbs to display a user's path within a site's hierarchy, helping them understand their location and easily navigate back to higher-level pages, especially on sites with deep structures.`}</p>
    <p>{`Breadcrumbs are most appropriate on pages that:`}</p>
    <ul>
      <li parentName="ul">{`Are missing section-level navigation elements E.g. `}<a parentName="li" {...{
          "href": "/brand/components/SubNav"
        }}>{`SubNav`}</a></li>
      <li parentName="ul">{`Need to surface contextually-relevant content through its parent page(s)`}</li>
    </ul>
    <h3>{`Placement`}</h3>
    <p>{`Place breadcrumbs at the top of the page, below the header and any navigation bar, to ensure they are immediately visible and accessible to users as they begin navigating the page.`}</p>
    <p>{`Align breadcrumbs with the main content area to maintain a consistent and orderly layout, helping users easily associate the breadcrumbs with the content they are navigating.`}</p>
    <p>{`Use consistent placement across all pages of the site so that users can rely on breadcrumbs as a stable navigation tool.`}</p>
    <h2>{`Accessibility`}</h2>
    <p>{`Ensure that the text of each individual Breadcrumb item fits entirely within a 320px wide viewport. Failure to do this violates `}<a parentName="p" {...{
        "href": "https://github.com/github/accessibility-audit-guide/blob/main/web/WCAG/1.4.10%20Reflow.md"
      }}>{`WCAG 1.4.10 Reflow`}</a>{`.`}</p>
    <DoDontContainer mdxType="DoDontContainer">
  <Do mdxType="Do">
    <img src={doOverflow} alt="" />
    <Caption mdxType="Caption">
      Use short Breadcrumb item names to ensure they fit within a 320px wide
      viewport.
    </Caption>
  </Do>
  <Dont mdxType="Dont">
    <img src={dontOverflow} alt="" />
    <Caption mdxType="Caption">
      Don't allow Breadcrumb item names to overflow the 320px wide viewport, as
      this violates WCAG 1.4.10 Reflow.
    </Caption>
  </Dont>
    </DoDontContainer>
    <h2>{`Options`}</h2>
    <h3>{`Variants`}</h3>
    <p>{`The breadcrumbs component is available in two variants:`}</p>
    <ul>
      <li parentName="ul">{`The default variant uses the standard text color, positioning the navigation as a secondary element on the page. This is suitable for most scenarios.  `}</li>
      <li parentName="ul">{`The accent variant emphasizes parent links with an accent color. This variant should should be reserved for pages where the breadcrumbs are essential for navigation.`}</li>
    </ul>
    <img src={variants} alt="The two breadcrumbs variants available: default and accent" />
    <h2>{`Related components`}</h2>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/brand/components/AnchorNav"
        }}>{`Anchor nav`}</a>{`: To display navigation for different sections of a page.`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/brand/components/Pagination"
        }}>{`Pagination`}</a>{`: To display navigation for content that is split into sequential pages.`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/brand/components/SubNav"
        }}>{`Sub nav`}</a>{`: To display the secondary navigation of a site.`}</li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      